import { type FC, type ReactElement } from 'react';
import { Link, useParams } from 'react-router-dom';
import { _notNil } from '@/littledash';
import { web as webRoute } from '@/support/route';
import type { AgentType } from '@/model/Agent.model';
import { parseAgentUrlSlug } from '@/components/Agents/AgentUtils';
import StudyHealthSetupForm from './Forms/StudyHealthSetupForm';

interface AgentFormConfig {
  label: string;
  render: () => ReactElement;
}

/** Maps agent slugs to their setup form config. */
const agentForms: Record<AgentType, AgentFormConfig> = {
  study_health_check: { label: 'Study Health Check', render: () => <StudyHealthSetupForm /> },
  study_protocol_parser: { label: 'Study Protocol Parser', render: () => <p className="mid-gray">Coming soon.</p> },
};

/** Generic agent setup page. Resolves the form component by agent slug from the URL. */
const AgentSetupPage: FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const agentType = _notNil(slug) ? parseAgentUrlSlug(slug) : undefined;
  const config = _notNil(agentType) ? agentForms[agentType] : undefined;

  return (
    <div className="ph4 pb4 pt3" data-testid="agent-setup-page">
      <div className="f5 mb3">
        <Link to={webRoute('agents')} className="blue link">
          In Vivo AI
        </Link>
        <span className="mh1 mid-gray">/</span>
        <span className="near-black">{config?.label ?? 'Setup'}</span>
      </div>
      {_notNil(config) ? config.render() : <p className="mid-gray">Agent not found.</p>}
    </div>
  );
};

export default AgentSetupPage;
